var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_115235",
    "data-name": "Group 115235",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.362,
    height: 22.609,
    viewBox: "0 0 18.362 22.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_106890",
    "data-name": "Path 106890",
    d: "M222.928,154.7a.529.529,0,0,0-.529.529V165.24a.529.529,0,1,0,1.059,0V155.233A.529.529,0,0,0,222.928,154.7Zm0,0",
    transform: "translate(-210.622 -146.512)",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_106891",
    "data-name": "Path 106891",
    d: "M104.928,154.7a.529.529,0,0,0-.529.529V165.24a.529.529,0,1,0,1.059,0V155.233A.529.529,0,0,0,104.928,154.7Zm0,0",
    transform: "translate(-98.871 -146.512)",
    fill: "red"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_106892",
    "data-name": "Path 106892",
    d: "M1.5,6.73V19.775a2.921,2.921,0,0,0,.777,2.015,2.607,2.607,0,0,0,1.892.818H14.187a2.607,2.607,0,0,0,1.892-.818,2.921,2.921,0,0,0,.777-2.015V6.73a2.023,2.023,0,0,0-.519-3.978H13.625V2.09A2.08,2.08,0,0,0,11.529,0h-4.7A2.08,2.08,0,0,0,4.73,2.09v.662H2.02A2.023,2.023,0,0,0,1.5,6.73ZM14.187,21.549H4.169a1.677,1.677,0,0,1-1.61-1.774v-13H15.8v13A1.677,1.677,0,0,1,14.187,21.549ZM5.789,2.09A1.02,1.02,0,0,1,6.827,1.058h4.7A1.02,1.02,0,0,1,12.566,2.09v.662H5.789ZM2.02,3.811H16.336a.953.953,0,0,1,0,1.906H2.02a.953.953,0,0,1,0-1.906Zm0,0",
    transform: "translate(0.003 0.001)",
    fill: "red"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_106893",
    "data-name": "Path 106893",
    d: "M163.928,154.7a.529.529,0,0,0-.529.529V165.24a.529.529,0,1,0,1.059,0V155.233A.529.529,0,0,0,163.928,154.7Zm0,0",
    transform: "translate(-154.746 -146.512)",
    fill: "red"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteImage);
export default __webpack_public_path__ + "static/media/delete_image.4cc5f2777c84312d78cb06e28b17e974.svg";
export { ForwardRef as ReactComponent };